var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ffcf99;}.c{fill:#be1e2d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10378 -459)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    rx: 11,
    transform: "translate(-10378 459)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10374.409 465.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.128)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-6.6-121.541c.5.223,1.1.512,1.1.512a4.168,4.168,0,0,1,1.968,2.742,4.762,4.762,0,0,1,.249,1.8,1.407,1.407,0,0,0,1.365.42s1.6-1.574.525-4.513a14.848,14.848,0,0,0,4.08-.262,1.051,1.051,0,0,0,.525-1.017,1.674,1.674,0,0,0-.354-1.1s.767-.164.77-1.426a1.433,1.433,0,0,0-.862-1.448,1.168,1.168,0,0,0,.39-1.2,1.049,1.049,0,0,0-.744-.951,1.58,1.58,0,0,0-.814-1.758,24.964,24.964,0,0,0-5.207-.22c-.494.044-2.317.172-3.071.863a1.085,1.085,0,0,0-.382.813c0,.24,0,5.95,0,5.95a.9.9,0,0,0,.461.794",
    transform: "translate(7.062 130.021)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.262)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-79.566-15.012a1.049,1.049,0,0,0-1.05-1.05h-3.464a1.05,1.05,0,0,0-1.05,1.05V-8.3a1.05,1.05,0,0,0,1.05,1.05h3.464a1.05,1.05,0,0,0,1.05-1.05Z",
    transform: "translate(85.129 16.062)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.04f7eb6a1d85bbcb9541b62851de6af7.svg";
export { ForwardRef as ReactComponent };